
import React from 'react';
import ExhibitAccessOptions from './ExhibitAccessOptions';
import WelcomeMessage from './WelcomeMessage';
import HomeImage from './HomeImage';
import VisitorInfoTeaser from './VisitorInfoTeaser';
import { useLanguage } from '@/context/LanguageContext';
import { usePublicSettings } from '@/hooks/usePublicSettings';
import { Skeleton } from '@/components/ui/skeleton';

interface MainContentProps {
  showSearchOnly?: boolean;
}

const MainContent = ({ showSearchOnly = false }: MainContentProps) => {
  const { t, language } = useLanguage();
  const { config, loading } = usePublicSettings();
  
  // Show loading skeleton while config is loading
  if (loading) {
    return (
      <div className="space-y-6">
        <Skeleton className="h-40 w-full rounded-xl" />
        <Skeleton className="h-20 w-full rounded-xl" />
        <Skeleton className="h-32 w-full rounded-xl" />
      </div>
    );
  }
  
  const elementComponents = {
    logo: config.show_logo && (
      <div key="logo" className="flex justify-center mb-4">
        <img 
          src={config.logo_url} 
          alt="Museum Logo" 
          className="w-full max-w-md h-auto rounded-xl overflow-hidden"
          onError={(e) => {
            e.currentTarget.src = "/lovable-uploads/727626ab-d59a-4f99-aed6-fe8a671929b5.png";
          }}
        />
      </div>
    ),
    welcomeMessage: config.show_welcome_message && <WelcomeMessage key="welcomeMessage" />,
    exhibitAccess: config.show_exhibit_access && <ExhibitAccessOptions key="exhibitAccess" settings={config} />,
    visitorInfo: config.show_visitor_info && <VisitorInfoTeaser key="visitorInfo" />,
    homeImage: config.show_home_image && <HomeImage key="homeImage" />
  };
  
  return (
    <>
      {!showSearchOnly && (
        <>
          {(config.element_order || ['logo', 'welcomeMessage', 'exhibitAccess', 'visitorInfo', 'homeImage']).map(elementKey => 
            elementComponents[elementKey as keyof typeof elementComponents]
          ).filter(Boolean)}
        </>
      )}
    </>
  );
};

export default MainContent;
